import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import GUIset_Single from "./gui/GUIset_Single";
import Template from "./TheTemplate";

const MaximumProduct = () => {
	const pageTitle = "Maximum Product when Cutting Rope";
	const title = "Maximum Product Cutting";
	const desc =
		"Given a rope of length n meters, cut the rope in different parts of integer lengths in a way that maximizes product of lengths of all parts. You must make at least one cut. Assume that the length of rope is more than 2 meters.";

	useEffect(() => {
		document.title = pageTitle;
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("10");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "") {
			process();
			BuildResult();
		}
	};

	var txt_time = "";
	var txt_time_cheat = "";
	var result; // { v: 0, items: [] };
	var result_cheat; // { v: 0, items: [] };
	var result2; // int
	var result_cheat;
	var memory = [];
	var memory2 = [];
	var n;
	var limit = 20000;

	function process() {
		memory = []; //no need to reset, but to see actual processing
		memory2 = [];
		n = parseInt(guiTxt1);
		Timer.start();
		// result = maxProd(x);
		// console.log("max " + result);
		if (n <= limit) {
			//when N < limit, show details, else only maximum
			result = maxProd(n, null);
			console.log("max " + result.v);
			console.log("item " + result.items);
		} else {
			result2 = maxProd_simple(n);
			console.log("max " + result2);
		}
		txt_time = Timer.stop_print();
		//--------
		Timer.start();
		result_cheat = maxProd_cheat(n);
		txt_time_cheat = Timer.stop_print();
		//clear memory
		memory = [];
		memory2 = [];
	}

	//int remain
	//best  { v: 0, items: [] };
	function maxProd(remain, best) {
		if (best == null) {
			//initialize as no cut
			best = { v: remain, items: [remain] };
		}
		if (remain <= 4) {
			//no cut if length <= 2
			return { v: remain, items: [remain] };
		}
		//---------
		for (var i = 3; i < remain; i++) {
			// subBest = maxProd(remain - i, null);
			//optimize by memory --------
			var j = remain - i;
			var subBest;
			if (memory[j] != null) {
				subBest = memory[j];
			} else {
				subBest = maxProd(j, null);
				memory[j] = subBest;
			}
			//-------------------------
			var newV = i * subBest.v;
			// console.log(best.items + " vs " + i + "x" + subBest.items);
			if (newV > best.v) {
				//Split
				best.v = newV;
				best.items = T.arr_cloneAddFront(subBest.items, i);
			}
		}
		return best;
	}

	// simple ver: no detail
	function maxProd_cheat(n) {
		var best = { v: 0, items: [] };
		while (n > 4) {
			best.v = best.v == 0 ? 3 : best.v * 3;
			best.items.push(3);
			n -= 3;
		}
		if (n > 0) {
			best.v = best.v == 0 ? n : best.v * n;
			best.items.push(n);
		}
		return best;
	}

	// simple ver: no detail
	function maxProd_simple(n) {
		if (n <= 4) {
			return n;
		}
		var max = 0;
		for (var i = 3; i < n; i++) {
			// max = Math.max(max, maxProd(n - i) * i);
			//optimize----------
			var j = n - i;
			var x;
			if (memory2[j] != null) {
				x = memory2[j];
			} else {
				x = maxProd_simple(n - i);
				memory2[j] = x;
			}
			max = Math.max(max, x * i);
		}
		return max;
	}

	//---------------------------------------------

	function BuildResult() {
		var txt;
		var txta;
		if (n <= limit) {
			txt = "Max Product: " + result.v;
			txta =
				"Ropes (length x number): " +
				T.arr_getFrequency_print(result.items, "x", " + ", false);
			// txta = result.items.join(" x ");
			// txta = "";
			// var freq = T.arr_getFrequency(result.items);
			// for (const [key, value] of Object.entries(freq)) {
			// 	if (txta != "") {
			// 		txta += " + ";
			// 	}
			// 	// if (value > 1) {
			// 	// 	// txta += "(" + key + "x" + value + ")";
			// 	// 	txta += key + "x" + value;
			// 	// } else {txta += key;}
			// 	txta += key + "x" + value;
			// }
		} else {
			txt = "Max Product: " + result2;
			txta = "*The number ropes is not reported to reduce processing memory";
		}
		txt += "\n" + txt_time;
		//
		var part1 = Template.simple3size("key1", "Result", txt, txta, 22, 20, 18);
		//------------
		var txt2 = "Max: " + result_cheat.v + "\n" + txt_time_cheat;
		// var txt2a = "Items: " + result_cheat.items.join(" x ");
		var txt2a =
			"Ropes (length x number): " +
			T.arr_getFrequency_print(result_cheat.items, "x", " + ", false);

		var part2 = Template.simple3size(
			"key1",
			"Shortcut Method",
			txt2,
			txt2a,
			16,
			20,
			18
		);
		//-------------
		partResultChange(
			<div>
				{part1}
				<br />
				{part2}
			</div>
		);
	}

	return (
		<GUIset_Single
			title={title}
			desc={desc}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"n"}
			label1Align={"right"}
			width1={"16%"}
			isNumOnly={true}
		/>
	);
};

export default MaximumProduct;
